import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { security } from '../../../settings/staticUrl'
import { Text, View } from '@olxbr/design-system'
import ShieldIcon from '../../atoms/ShieldIcon'

import Link from '../../atoms/Link'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
`
const Info = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Icon = styled(View)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 26px;
`

const BlockText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 4px;
  padding-right: 36px;
`

const GoToTipsPageLink = styled(Link)`
  text-align: left;
`

class SecurityTipsBlock extends React.Component {
  onSecurityLinkClick = () => {
    const { onSecurityLink } = this.props
    if (onSecurityLink && typeof onSecurityLink === 'function') {
      onSecurityLink()
    }
  }

  render() {
    return (
      <Content>
        <Icon>
          <ShieldIcon />
        </Icon>
        <Info>
          <BlockText>
            Entenda como a OLX cuida da sua segurança e veja dicas de como fazer uma negociação
            segura.
          </BlockText>

          <GoToTipsPageLink
            preventHrefOnClick={false}
            href={security}
            onClick={this.onSecurityLinkClick}
            type="primary"
            underline={false}
            rel="noopener noreferrer"
            target="_blank"
          >
            Acessar página de segurança
          </GoToTipsPageLink>
        </Info>
      </Content>
    )
  }
}

SecurityTipsBlock.propTypes = {
  onSecurityLink: PropTypes.func,
}

export default SecurityTipsBlock
